<template>
  <div class="content--sinoreg">
    <div class="Fornecedores">
      <div class="Fornecedores_header">
        Beneficiários
      </div>
      <div class="Fornecedores_search m-2">
        <div class="row align-items-end justify-content-between">
          <div class="col-5">
            <label for="fornecedor">Buscar beneficiário</label>
            <input id="fornecedor"
                   v-model="localData.nome"
                   type="text"
                   class="form-control form-control-sm"
                   @change="getFornecedores()"
                   @keydown.enter="getFornecedores()">
          </div>

          <button class="btn btn-sm btn-primary mr-2"
                  @click="showForm = true">
            <icon-svg icon="add"
                      class="icon-add icon--sm" />
            Adicionar Beneficiário
          </button>
        </div>
      </div>
      <div v-if="fornecedores.length"
           class="Fornecedores_results mt-3">
        <ListagemFornecedores :prop-fornecedores="fornecedores"
                              @excluirFornecedor="excluirFornecedor"
                              @editarFornecedor="editarFornecedor"
                              @atualizarFornecedor="atualizarFornecedor" />
        <Pagination
          class="mt-4"
          :per-page="perPage"
          :page="page"
          :last-page="lastPage"
          :select-page="true"
          @onPreviousPage="[page = page - 1, getFornecedores()]"
          @onNextPage="[page = page + 1, getFornecedores()]"
          @onSetPage="page => goPage(page)" />
      </div>
      <div v-else
           class="row justify-content-center my-5">
        <b>Nenhum resultado encontrado</b>
      </div>
    </div>
    <FormFornecedor v-if="showForm"
                    :prop-fornecedor="fornecedor"
                    @cadastrar="cadastrarFornecedor"
                    @editar="atualizarFornecedor"
                    @hide="hideForm()" />
  </div>
</template>

<script>
  //Components
  import Pagination from "@/components/SofiaRei/Pagination"
  import FormFornecedor  from "@/components/SofiaRei/Fornecedores/FormFornecedor"
  import ListagemFornecedores  from "@/components/SofiaRei/Fornecedores/ListagemFornecedores"

  //Service
  import FornecedorService from "@/services/FornecedorService"

  export default {
    name: 'Fornecedores',
    components: {
      Pagination,
      FormFornecedor,
      ListagemFornecedores
    },
    data () {
      return {
        showForm: false,
        localData: {
          tipo: null,
          nome: null
        },
        fornecedor: null,
        perPage: 10,
        page: 1,
        lastPage: 1,
        fornecedores: [],
      }
    },
    mounted () {
      this.getFornecedores()
    },
    methods: {
      async getFornecedores () {
        try {
          loader({active: true, text: 'Buscando fornecedores...'})

          const res = await FornecedorService.getFornecedores({
            ...this.localData,
            page: this.page,
            perPage: this.perPage
          })

          if (res) {
            this.fornecedores = res.data
            this.page = res.page
            this.perPage = res.perPage
            this.lastPage = res.lastPage
          }

        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: null})
        }
      },
      editarFornecedor (fornecedor) {
        this.fornecedor = {...fornecedor},
        this.showForm = true
      },
      async cadastrarFornecedor (fornecedor) {
        try {
          loader({active: true, text: 'Cadastrando fornecedor...'})

          const res = await FornecedorService.cadastrarFornecedor(fornecedor)

          if (res) {
            displayMessage('success', 'Beneficiário cadastrado com sucesso!').then(() => {
              this.showForm = false
              this.getFornecedores()
            })
          }

        } catch (error) {
          const message = getErrors(error)

          if (message.message && message.message.match('fornecedor_nome_cartorio_id_unique')) {
            message.message = 'Já existe um beneficiário com o mesmo nome.'
          } else if (message.message && message.message.match('fornecedor_cnpj_cartorio_id_unique')) {
            message.message = 'Já existe um benefiário com o mesmo CNPJ.'
          }

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: null})
        }
      },
      async atualizarFornecedor (fornecedor) {
        if (!Object.values(fornecedor).length) {
          displayMessage('success', 'Nada para atualizar!')
          this.hideForm()
          return
        }

        try {
          loader({active: true, text: 'Atualizando fornecedor...'})

          const res = await FornecedorService.atualizarFornecedor(fornecedor, fornecedor.fornecedor_id)

          if (res) {
            displayMessage('success', 'Beneficiário atualizado com sucesso!').then(() => {
              this.showForm = false
              this.getFornecedores()
            })
          }

        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: null})
        }
      },
      async excluirFornecedor (fornecedor) {
        try {
          loader({active: true, text: 'Excluindo fornecedor...'})

          const res = await FornecedorService.excluirFornecedor(fornecedor.fornecedor_id)

          if (res) {
            displayMessage('success', 'Beneficiário excluido com sucesso!').then(() => {
              this.showForm = false
              this.getFornecedores()
            })
          }

        } catch (error) {
          const message = getErrors(error)

          if (typeof message.message === 'string' && message.message.match('Cannot delete or update a parent row: a foreign key constraint fails')) {
            return displayMessage('error','Erro!',  'Não é possível excluir um beneficiário vinculado a um lançamento.')
          }

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: null})
        }
      },
      hideForm () {
        this.fornecedor = null
        this.showForm = false
      },
      goPage (page) {
        this.page = page
        this.getFornecedores()
      }
    }
  }
</script>

<style lang="scss">
  .Fornecedores {
    &_header {
      background: #074f7f;
      color: #fff;
      padding: 10px;
      font-size: 20px;
      font-weight: bold;
    }
  }

  .Fornecedores label {
    font-size: 15px;
    font-weight: 500;
    color: #373a3c;
  }

  .icon-add {
    fill: #fff !important;
    width: 18px;
    height: 18px;
  }
</style>
